
<div class="close-button-wrapper">
    <button id="closebutton" aria-label="close filter options" type="button"
(click)="closeDialog()">CLOSE <span class="material-symbols-outlined cancel-icon">
    cancel
</span> </button>
</div><div class="dialog-wrapper" aria-label="learn-more dialog">

    <div class="modal-body">

        <h4>Domain</h4>
        <h3>{{data.comp_name}}</h3>
        <h4>Domain Statement</h4>

        <div class="content-box" [ngSwitch]="data.comp_name">

            <!-- Legal Practice -->
            <div *ngSwitchCase="'Legal Practice'">
                <p class="statement">Lawyers can accurately identify legal issues. Lawyers employ research, analytical and problem-solving skills to formulate clear and appropriate legal strategies. Lawyers are effective communicators and advance their clients’ interests within their practice-specific contexts.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Critically evaluate a matter</td>
                        <td>
                            <ul>
                                <li>Use appropriate and current substantive and procedural law applicable to one’s own practice area(s)</li>
                                <li>Accurately identify relevant facts, legal issues and informational gaps or discrepancies</li>
                                <li>Gather with due diligence all relevant information</li>
                                <li>Research, interpret and correctly apply common law, statutes, regulations, rules, procedure, policy and theory to a legal issue</li>
                                <li>Seek relevant expertise on a matter when needed</li>
                                <li>Prudently assess possible courses of action, by considering the range of potential outcomes and weighing the risks of each</li>
                                <li>Create legal strategy appropriate and proportionate to client needs and means</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Communicate effectively</td>
                        <td>
                            <ul>
                                <li>Express concepts clearly, precisely, logically, accurately and concisely</li>
                                <li>Use plain language where appropriate</li>
                                <li>Adapt communications appropriately to different contexts, purposes and audiences (courts, clients, lawyers, <span matTooltipClass="tooltip-class" class="dotted-underline" [matTooltip]="enumerated_groups">enumerated groups</span>, other individuals)</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Advance client interests</td>
                        <td>
                            <ul>
                                <li>Present well-prepared, accurate and appropriate legal argument and analysis</li>
                                <li>Use persuasive communication</li>
                                <li>Adapt legal strategy or approach and pivot as circumstances change</li>
                                <li>Take steps to protect client interests</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <div *ngSwitchCase="'Continuous Improvement'">
                <!-- Continuous Improvement -->
                <p class="statement">Lawyers are committed to continuous improvement of legal service delivery and to lifelong
                    learning, with the goal of providing the highest quality legal services.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by
                    each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Commit to continuous improvement in the provision of services</td>
                        <td>
                            <ul>
                                <li>Proactively seek feedback and input from clients and others to identify aspects of service that could be enhanced</li>
                                <li>Demonstrate adaptability and openness to new ideas</li>
                                <li>Foster innovation and development of best practices</li>
                                <li>Develop solutions to overcome obstacles to implementation of best practices</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Cultivate a <span matTooltipClass="tooltip-class" [matTooltip]="growth_mindset"class="dotted-underline">growth mindset</span></td>
                        <td>
                            <ul>
                                <li>Engage in intentional self-reflection, goal setting, and professional development planning</li>
                                <li>Continuously identify opportunities for professional development and improvement</li>
                                <li>Engage in work or training that will expand skills, knowledge or responsibilities</li>
                                <li>Encourage and support colleagues in undertaking new learning and development</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <div *ngSwitchCase="'Cultural Competence, Equity, Diversity and Inclusion'">
                <!-- Cultural Competence, Equity, Diversity and Inclusion -->
                <p class="statement">Lawyers have an awareness of the unique experiences of the <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="enumerated_groups">enumerated groups</span> set out in the Alberta Human Rights Act. They implement strategies to meet the specific needs of individuals from these groups to achieve culturally or community-appropriate services and outcomes. Lawyers treat all people with dignity and respect and take active steps to support and advocate for members of <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="enumerated_groups">enumerated groups</span>.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Build intelligence related to cultural competence, equity, diversity and inclusion</td>
                        <td>
                            <ul>
                                <li>Develop understanding of <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="enumerated_groups">enumerated groups</span> as set out by the Alberta Human Rights Act</li>
                                <li>Develop self-awareness of how one’s own conscious and unconscious biases affect perspectives and actions</li>
                                <li>Reduce one’s own biases through continual education, self-reflection and inquiry</li>
                                <li>Recognize how systemic inequalities and barriers affect individuals and groups</li>
                                <li>Develop an awareness of the effects of individual and systemic trauma</li>
                                <li>Consider how multiple points of discrimination interact to create barriers for individuals</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Incorporate equity, diversity and inclusion in practice</td>
                        <td>
                            <ul>
                                <li>Practise anti-discrimination and anti-racism</li>
                                <li>Ensure that services are accessible to all</li>
                                <li>Develop and promote a deeper understanding of sexual orientation and gender identity</li>
                                <li>Take action to accommodate visible and invisible disabilities</li>
                                <li>Implement strategies to mitigate trauma</li>
                                <li>Take action to dismantle systemic inequalities and barriers</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Champion <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="enumerated_groups">enumerated groups</span> in professional activities</td>
                        <td>
                            <ul>
                                <li>Advance inclusion through intentional, positive and conscious efforts</li>
                                <li>Respect the diverse cultures, perspectives, backgrounds, interests and goals of clients, co-workers and colleagues</li>
                                <li>Adapt communication for <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="enumerated_groups">enumerated groups</span> as applicable</li>
                                <li>Advocate for those facing systemic barriers to accessing what they need or deserve</li>
                                <li>Advocate for hiring, promotion and retention in a manner consistent with enhancing diversity, equity and inclusion</li>
                                <li>Promote a healthy, safe and inclusive workplace</li>
                                <li>Increase awareness of qualifications of internationally trained lawyers</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Lawyer-Client Relationships -->
            <div *ngSwitchCase="'Lawyer-Client Relationships'">
                <p class="statement">Lawyers assess lawyer-client relationships, both internal and external, for suitability and clearly establish the scope of the relationships. Lawyers communicate effectively with their clients and connect with them in a professionally appropriate manner. Lawyers are mindful of and attentive to the entirety of their clients’ circumstances and support clients in pursuing their goals, priorities and broader interests.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Determine suitability of lawyer-client relationships</td>
                        <td>
                            <ul>
                                <li>Accurately assess and reassess risks associated with potential and existing client relationships</li>
                                <li>Evaluate if personal considerations might impact lawyer-client relationships</li>
                                <li>Provide appropriate referrals when it is in the client’s best interests</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Establish lawyer-client relationships</td>
                        <td>
                            <ul>
                                <li>Clarify when providing general legal information versus legal advice which would trigger a client relationship</li>
                                <li>Listen actively to understand client expectations, build trust and foster exchange of information</li>
                                <li>Accurately identify who is authorized to give instructions and receive information</li>
                                <li>Obtain, clarify and document client instructions and confirm course of action</li>
                                <li>Clearly communicate the terms and limits of the lawyer’s scope of work/retainer for the client, including fees, and act accordingly</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Engage in ongoing communication with clients</td>
                        <td>
                            <ul>
                                <li>Proactively and regularly communicate to keep clients informed</li>
                                <li>Respond to client communications in a timely manner</li>
                                <li>Manage client expectations</li>
                                <li>Communicate respectfully and empathetically</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Foster collaborative and trusting lawyer-client relationships</td>
                        <td>
                            <ul>
                                <li>Candidly and thoroughly inform clients of their options and potential outcomes</li>
                                <li>Ensure clients understand information and advice provided</li>
                                <li>Empower clients to act on own behalf or seek out resources when appropriate</li>
                                <li>Consider the entirety of each client’s circumstances in all aspects of a matter</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Practice Management -->
            <div *ngSwitchCase="'Practice Management'">
                <p class="statement">Lawyers employ a range of strategies and skills to support the delivery of efficient and effective legal services and internal processes. Lawyers manage and mitigate risks to their practice and use technology and innovation to improve legal services.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Use effective time management and organization skills</td>
                        <td>
                            <ul>
                                <li>Anticipate and prioritize case, project and workload needs</li>
                                <li>Verify that new assignments are within one’s own capacity</li>
                                <li>Perform all work in a timely and cost-effective manner</li>
                                <li>Fully utilise practice management tools and software (e.g., checklists, diary, conflict check system)</li>
                                <li>Delegate tasks that can appropriately and efficiently be performed by others</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Manage files effectively and securely</td>
                        <td>
                            <ul>
                                <li>Secure files to prevent unauthorized access</li>
                                <li>Use file management systems that support efficient file tracking, retrieval, retention and destruction</li>
                                <li>Adhere to privacy and confidentiality requirements</li>
                                <li>Ensure matters are thoroughly and clearly documented</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Use effective accounting and billing procedures</td>
                        <td>
                            <ul>
                                <li>Ensure timely and regular billing practices in accordance with retainer agreements or other applicable billing guidelines</li>
                                <li>Implement practices and procedures to ensure compliance with Law Society reporting and accounting requirements applicable to practice</li>
                                <li>Access available resources related to billing and accounting when clarification or advice needed</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Supervise and manage effectively</td>
                        <td>
                            <ul>
                                <li>Provide required information and relevant instructions for efficient delegation</li>
                                <li>Ensure quality of work produced by others</li>
                                <li>Provide necessary and useful support and direction to others through training and constructive feedback</li>
                                <li>Manage conflict between individuals and groups in practice and model appropriate conflict resolution behaviours</li>
                                <li>Seek and apply tools to build and enhance management skills</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Assess and manage <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="practice_risks">practice risks</span></td>
                        <td>
                            <ul>
                                <li>Implement processes for regular, thorough and honest assessment of <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="practice_risks">practice risks</span></li>
                                <li>Create plans and strategies to mitigate identified <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="practice_risks">practice risks</span></li>
                                <li>Engage in <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="business_continuity_planning">business continuity</span> and succession planning</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Demonstrate technological competence</td>
                        <td>
                            <ul>
                                <li>Evaluate risks and benefits of potential technological innovations to clients and to one’s own practice</li>
                                <li>Advocate for the timely and appropriate adoption of technology to increase efficiency and effectiveness of legal practice</li>
                                <li>Use technology, the internet and digital platforms responsibly</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Professional Conduct -->
            <div *ngSwitchCase="'Professional Conduct'">
                <p class="statement">Lawyers are honest, trustworthy and act with integrity. Lawyers execute good judgment and adhere to high standards of behaviour and accountability – to their clients, co-workers, colleagues, members of the legal profession, the courts, tribunals and the Law Society.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Act ethically</td>
                        <td>
                            <ul>
                                <li>Accurately recognize, anticipate and resolve ethical issues that arise in legal practice</li>
                                <li>Consistently and decisively make informed and reasoned decisions about ethical issues</li>
                                <li>Implement practices and procedures that ensure individual and organizational compliance with requirements related to ethical and indemnity obligations, including case law, statutory requirements, the Code of Conduct and Rules of the Law Society of Alberta</li>
                                <li>Promptly consult with others (e.g., Practice Advisors, colleagues) when it is unclear how to act ethically in a given situation</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Demonstrate good character</td>
                        <td>
                            <ul>
                                <li>Continuously demonstrate integrity, honesty and trustworthiness</li>
                                <li>Consistently practise civility and respect in interactions with others</li>
                                <li>Act on a good-faith basis when dealing with clients, co-workers, colleagues, the legal profession and the public</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Use sound judgement</td>
                        <td>
                            <ul>
                                <li>Make logical decisions based on all available information and potential outcomes</li>
                                <li>Seek out additional information when there are gaps in knowledge</li>
                                <li>Promptly recognize when tasks or matters fall outside one’s own competence and access appropriate sources when assistance or referral is required</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Professional Contributions -->
            <div *ngSwitchCase="'Professional Contributions'">
                <p class="statement">Lawyers foster professional relationships with their colleagues, opposing counsel, courts and tribunals, the Law Society, other professional groups, pro bono organizations, and generally support the administration of justice and enhancements to the legal system. Lawyers strive to strengthen the profession and, where possible, promote and improve <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="access_to_legal_services">access to legal services</span> and access to justice.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Foster collegiality and civility in the legal profession</td>
                        <td>
                            <ul>
                                <li>Demonstrate professional courtesy, honesty, candour, respect and civility in dealings with clients, colleagues, the courts, tribunals and others</li>
                                <li>Work constructively with others to resolve issues in a timely and cost-effective manner when appropriate</li>
                                <li>Acknowledge and consider other viewpoints, and express any disagreement thoughtfully and respectfully</li>
                                <li>Work collaboratively with colleagues within the lawyer’s work environment</li>
                                <li>Mentor peers and/or junior colleagues</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Enhance the administration of justice</td>
                        <td>
                            <ul>
                                <li>Actively volunteer with or otherwise support professional associations and community organizations</li>
                                <li>Promote a clear and accurate understanding of the legal profession to others (e.g., the media, the public)</li>
                                <li>Foster dialogue between lawyers and the judiciary</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Advance <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="access_to_legal_services">access to legal services</span> and
                            access to justice</td>
                        <td>
                            <ul>
                                <li>Recognize how access to justice issues impact the justice system</li>
                                <li>Enhance <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="access_to_legal_services">access to legal services</span>  for everyone</li>
                                <li>Provide pro bono services and support pro bono organizations</li>
                                <li>Ensure matters proceed effectively and efficiently</li>
                                <li>Collaborate with others to make systemic improvements to increase access to justice</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Truth and Reconciliation -->
            <div *ngSwitchCase="'Truth and Reconciliation'">
                <p class="statement">Lawyers are integral to the development, interpretation and application of laws. Alberta lawyers understand the historical and current impacts that Canadian law has on Indigenous Peoples (First Nations, Inuit and Métis) in Canada and participate in reconciliation.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Strengthen understanding of the truth regarding the experience of Indigenous Peoples in Alberta and Canada</td>
                        <td>
                            <ul>
                                <li>Recognize the history and diversity of various Indigenous communities of Alberta and Canada</li>
                                <li>Understand the terminology used to describe Indigenous Peoples and its significance at law</li>
                                <li>Acknowledge the impacts of colonization and systemic discrimination</li>
                                <li>Respect the differences among traditional lands, Treaty territories and Métis Settlements in Alberta</li>
                                <li>Acknowledge the discriminatory practices that have been applied to Indigenous Peoples in Canada</li>
                                <li>Understand the history of Indian Residential Schools and day schools and their impact on the well-being of Indigenous Peoples</li>
                                <li>Recognize the historical and ongoing impacts of Canadian and Alberta law on Indigenous Peoples</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Demonstrate support for reconciliation with the Indigenous Peoples of Canada</td>
                        <td>
                            <ul>
                                <li>Apply Calls for Action and Calls for Justice applicable to Indigenous Peoples</li>
                                <li>Acknowledge and respect the traditional Indigenous territory in which the lawyer practises or lives</li>
                                <li>Incorporate Indigenous principles, laws, culture and perspectives when developing strategies for representing Indigenous clients</li>
                                <li>Recognize that Indigenous Peoples have their own restorative justice systems and use them where appropriate</li>
                                <li>Enhance access to restorative justice initiatives and options </li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Well-being -->
            <div *ngSwitchCase="'Well-being'">
                <p class="statement">Lawyers make their own physical, mental and emotional well-being a priority in order to ensure their capacity to practise competently. They manage the stresses of practice in the ways that are effective for their individual circumstances in order to provide high-quality legal services and promote healthy workplaces. Lawyers support and foster others’ well-being.</p>
                <h4>Performance Indicators</h4>
                <p>The performance indicators below illustrate observable or readily inferable behaviours in the area outlined by each competency. They provide examples of different aspects of the competency that a lawyer can develop.</p>
                <table class="indicator">
                    <tr>
                        <th>Competency</th>
                        <th>Performance Indicators</th>
                    </tr>
                    <tr>
                        <td>Build <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="resilience">resilience</span></td>
                        <td>
                            <ul>
                                <li>Develop flexibility and adaptability in the face of adversity or stress</li>
                                <li>Mitigate effects of stress and trauma, accessing supports as needed</li>
                                <li>Approach challenges as opportunities to learn, grow and improve, where appropriate</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Maintain personal health</td>
                        <td>
                            <ul>
                                <li>Practise physical, mental, and emotional self-care and health management</li>
                                <li>Strive to consistently use <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="healthy_coping_skills">healthy coping skills</span></li>
                                <li>Identify and seek out resources for support for personal problems that might interfere with one’s own ability to practise</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Demonstrate self-awareness</td>
                        <td>
                            <ul>
                                <li>Recognize one’s own stressors and how they manifest</li>
                                <li>Recognize impact of one’s own behaviours on others’ well-being</li>
                                <li>Take concrete steps to ensure work-life challenges do not have an adverse impact personally and professionally</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Support well-being of others</td>
                        <td>
                            <ul>
                                <li>Encourage adoption of <span class="dotted-underline" matTooltipClass="tooltip-class" [matTooltip]="healthy_coping_skills">healthy coping skills</span> and stress management practices</li>
                                <li>Demonstrate empathy toward others in professional settings</li>
                                <li>Strive to foster optimal health and well-being of others in professional settings</li>
                                <li>Recognize signs of distress/struggle in others</li>
                                <li>Assist others in obtaining supports for their well-being</li>
                            </ul>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Additional domains -->
            <div *ngSwitchDefault>
                <p class="statement">{{domainStatement}}</p>
            </div>

        </div>

    </div>
</div>
